const getHighchartsBundle = async () => {
  //Dynamically inject highcharts
  if (typeof window.Highcharts != "object") {
    console.log("Highcharts not loaded, loading now.");
    window.Highcharts = await import("highcharts");
  }
};

export default getHighchartsBundle;
